var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.429,
    height: 24,
    viewBox: "0 0 27.429 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    d: "M24.765,3.889a7.326,7.326,0,0,0-10,.729L13.714,5.7,12.658,4.617a7.325,7.325,0,0,0-10-.729,7.692,7.692,0,0,0-.53,11.137L12.5,25.729a1.679,1.679,0,0,0,2.427,0l10.366-10.7a7.687,7.687,0,0,0-.525-11.137Z",
    transform: "translate(0.001 -2.248)",
    fill: "#030326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ee382be03870b7669d40f51e2f327182.svg";
export { ForwardRef as ReactComponent };